import ApiService from "./ApiService";

// export async function apiSignIn(data) {
//   return ApiService.fetchData({
//     url: "/login-post.php",
//     method: "post",
//     data,
//   });
// }

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: "/v3/login",
    method: "post",
    data,
  });
}
export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: "/sign-up",
    method: "post",
    data,
  });
}

export async function apiSignOut(data) {
  return ApiService.fetchData({
    url: "/sign-out",
    method: "post",
    data,
  });
}

export async function apiForgotPassword(data) {
  return ApiService.fetchData({
    url: "/v3/forgot-password",
    method: "post",
    data,
  });
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: "/v3/forgot-password-set",
    method: "post",
    data,
  });
}
export async function apiChangePassword(data) {
  return ApiService.fetchData({
    url: "/miscellaneous.php",
    method: "post",
    data,
  });
}

/**
 * Fetch the academic resources.
 * @param {Object} data - The query parameters as key-value pairs.
 * @returns {Promise<Object>} - The API response.
 */
export async function apiGetCheckedValidURL(data) {
  const searchParams = new URLSearchParams(data);
  return ApiService.fetchData({
    url: `/v3/forgot-password-valid-url?${searchParams.toString()}`,
    method: "get",
  });
}
